module.exports = __webpack_public_path__ + "static/media/withdrawals-color.a0841229.svg";